module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABY0lEQVQ4T61TO07DQBCdtaO4SxyapIkTXCFAgkNQkHtAwaeAi/ApQkOugUSBOANI/Cobu7Ib7ERIyJbs8GZlR6vIRYRZyZ7188ybebOzgpaW53mbeZ4fAB7N5/N1/i2EcGDuNU2bDAaDNzVElB9wbrquewHnI+y1ZeKCKIe9bTQa5/1+/0di/CqC77DdqwpcxpDkcTgcjmBTSeA4zhjmeJVgxWds2/apgOYtaH5GFXpRJpkdk2bTGWVZJv11XadWu0VxFHO1EkP2DD3ZEdB9CfCsZO6sdchsm5QkCYVhKOFut0uGYVA8jSn6ihZFgOSKCd5BsFGinK0MYBJeHJymKQVBsKiqqOJDQD97NVX9KgnjVcGFf1pJAG3U6/VkZl6lnLInSrLvlSVUkaAHr3WbeC18399GaU9/OUb0arfOIN1gkE7+Z5S5q7UukzoDxWgfAtsHqc0XBvtPPA/QPLEs60X1/wURwOcPgMPBywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backstage-genus-close.png
// module id = NBpV
// module chunks = 1